// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3IfAy","filesListContainer":"PosDisputesFiles_filesListContainer__2_nS_","filesButton":"PosDisputesFiles_filesButton__1NwsH"};